var specialProduct = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  // if (itemCollections.toLowerCase().indexOf('Holiday'.toLowerCase()) > -1) {
  //   specialProduct = true;
  // } 

  // if (itemCollections.toLowerCase().indexOf('november 22'.toLowerCase()) > -1) {
  //   specialProduct2 = true;
  // } 

  if (itemTitle.toLowerCase().indexOf('Baguette'.toLowerCase()) > -1) {
    //specialProduct = true;
  } 

  if (itemTitle.toLowerCase().indexOf('Epi'.toLowerCase()) > -1) {
    specialProduct = true;
  } 

  if (itemTitle.toLowerCase().indexOf('Focaccia'.toLowerCase()) > -1) {
    specialProduct = true;
  } 

  // Added to setup different time
  if (itemTitle.toLowerCase().indexOf('Focaccia'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 
}

var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  var selectedDayNumber = selectedDate.getDate();
  if (selectedDayNumber === currentDay && currentMonth === selectedMonth) { 
    timepicker.set('disable',[{ from: [8, 0], to: [23, 0] }]); 
  }
console.log(selectedDayNumber)
//   if(selectedDate.getDate() === 17 && selectedMonth === 8) {
//   	timepicker.set('disable',[{ from: [11, 00], to: [11, 00] }]); 
//   }
	
}

////
var overridingRules = [];

for (let item of crItems) {
    const crItemId = item.id;
    for (let rule of CRoverRidingRules) {
        for (let product of rule.products) {
            for (let variant of product.variants) {
                const variantId = Number(variant.plainVariantId);
                if (variantId == crItemId) {
                    overridingRules.push(rule.name)
                }
            }
        }
    }
}
// If the overridingRules contains the same element we don't need to display the mssage,
// otherwise it means that products from multiple rules are in the cart
const allEqual = arr => arr.every( v => v === arr[0] )
console.log(overridingRules, allEqual(overridingRules))
var displayMessage = false;
if (overridingRules.length > 1 && !allEqual(overridingRules) ) {
    displayMessage = true;
}
// This was commented out on Oct 1, 2024
/* if (overridingRules.length && specialProduct === true ) {
   displayMessage = true;
}*/

document.addEventListener('crJQActivated', function (e) {
  if (displayMessage === true) {
    jqCR('#pickup-container').remove()
    console.log('display')
      setTimeout(function(){        
        jqCR('.cr-block-message').text("Dear customer, please note that certain products are only baked on specific days. Your basket contains one or more items not available on your pick up date. Please consult the bread schedule and edit accordingly")
        disableCheckoutButton2();
        var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
        setTimeout(function() { clearInterval(tt); }, 10000);  

      }, 100)
  }  
})

function activateCheckoutButton2(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('[name=checkout]').disabled = true;
}
// overriding rules enabled even if we add custom rules
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
   if (specialProduct === true && overridingRules.length > 1) {     // this condition was added on Oct 1, 2024 ->  && overridingRules.length > 1 
   	picker.set('disable', [true, 
                           2,3
                           //[2023, 8, 3], [2023, 8, 9], [2023, 8, 10], [2023, 8, 23] 
                          ]);
    //picker.set('disable', blackoutdatesCollection);
   } else {
    var overridingProducts = false;

    if (storePickup.overridingRules.length) {
        storePickup.overridingRules.forEach((overridingRule, index) => {
            overridingProducts  = true;
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentDay = today.getDate();
            const currentYear = today.getFullYear()

            overridingRule.enabledDates.forEach((enabledDay, index) => {
                if (typeof disabledDates !== 'undefined' && !jqCR.isEmptyObject(disabledDates)) {
                    for (const i in disabledDates) {
                        const foundDate = i;
                        const chunks = foundDate.split('/');
                        const disabledMonth = Number(chunks[0]) - 1;
                        const disabledDay = Number(chunks[1]);
                        const disabledYear = Number(chunks[2]);
                        if (enabledDay[0] === disabledYear && enabledDay[1] === disabledMonth && enabledDay[2] === disabledDay
                        ) {
                            //console.log('Number of orders limit per day has been reached')
                        } else if (enabledDay[0] >= currentYear && enabledDay[1] >= currentMonth && enabledDay[2] >= currentDay) {
                            picker.set('disable', [enabledDay])
                        }
                    }
                } else if (
                    (enabledDay[0] > currentYear) ||
                    (enabledDay[0] == currentYear && enabledDay[1] > currentMonth) ||
                    (enabledDay[0] == currentYear && enabledDay[1] == currentMonth && enabledDay[2] >= currentDay)
                ) {

                    const foundDate = new Date(enabledDay[0], enabledDay[1], enabledDay[2]);
                    const diff = foundDate.getTime() - today.getTime();
                    const totalDiffDays = Math.ceil(diff / (1000 * 3600 * 24));

                    // Keep minimum pickup days set within the app settings
                    if (typeof storePickupSettings.min_days !== 'undefined' && totalDiffDays < storePickupSettings.min_days) return;
                    picker.set('disable', [enabledDay])
                }

            })
            picker.set('min', -1)
        })  
        picker.set('disable', 'flip')
    }  else {
      picker.set('disable', blackoutdatesCollection);
    }
  }
}
var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  //console.log(selectedDay, selectedDate, selectedMonth);
  if(specialProduct === true) {
  	
    timepicker.set('min',[9, 30]); 
    //timepicker.set('max',[17, 0]);
  }

  if(specialProduct2 === true) {
    timepicker.set('min',[11, 0]);   
  }
	
}
/// end of special overriding rules script
/*var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  console.log({blackoutdatesCollection})
  if (specialProduct === true && !overridingRules.length) {
  	picker.set('disable', [true, 
                           //{ from: [2020, 8, 10], to: [2020, 8, 23] }, 
                           //{ from: [2020, 9, 13], to: [2022, 9, 7] }
                          ]);
    //picker.set('max', storePickupSettings.max_days);   
  }	else {
    picker.set('disable', blackoutdatesCollection);  
  }  
  
}*/